import React, { useContext, useState, useEffect, memo } from "react";
import { makeStyles } from "@mui/styles";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
} from "@mui/material";

import { withRouter } from "react-router-dom";
// import Spinner from "../../../Spinner/Spinner";

import Row from "./Row";
import Cargando from "../../../../components/Extra/Cargando";
import ToolBarTable from "./ToolBarTable";
import TablaCabecera from "./TablaCabecera";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { usePermiso } from "../../../../hooks/usePermiso";
import MenuContext from "../../../../Context/Menu/MenuContext";
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 600,
  },
});
const Tabla = (props) => {
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  const { rows: rowsMenu } = useContext(MenuContext);
  const { tienePermiso, alertaPermiso } = usePermiso("Mascotas");
  // ADMIN Y SIDEBAR
  // HistorialClinica
  // // // CarnetVacunas
  // // Recetas
  // // Hospitalizacion
  // // Peluqueria
  // // Examenes
  const tienePermisoTab = (componentName) => {
    const component = rowsMenu.find(
      (itemMenu) => itemMenu.sidInfo.component === componentName
    );

    const esCategoriaEmpresa = component.sidInfo.categoriaEmpresa.some(
      (itemCatEmp) => itemCatEmp === usuario.empCategoria
    );
    if (!esCategoriaEmpresa) {
      return "NO";
    }

    if (!usuario.permisos_usuario[usuario.rucempresa]) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res ? "SI" : "NO";
    }
    if (
      !usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
    ) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res ? "SI" : "NO";
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 0
    ) {
      const res = component.sidInfo.permisos.some((itemPermiso) => {
        return usuario.rol.some(
          (itemRolUsuario) => itemRolUsuario === itemPermiso
        );
      });

      return res ? "SI" : "NO";
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 1
    ) {
      return "SI";
    }
    if (
      usuario.permisos_usuario[usuario.rucempresa][component.sidInfo.component]
        .permisos === 2
    ) {
      return "NO";
    }
  };

  const [permisoHistorialClinica, setpermisoHistorialClinica] = useState(null);
  // HistorialClinica;
  const [permisoCarnetVacunas, setpermisoCarnetVacunas] = useState(null);
  // CarnetVacunas;
  const [permisoRecetas, setpermisoRecetas] = useState(null);
  // Recetas;
  const [permisoHospitalizacion, setpermisoHospitalizacion] = useState(null);
  // Hospitalizacion;
  const [permisoPeluqueria, setpermisoPeluqueria] = useState(null);
  // Peluqueria;
  const [permisoExamenes, setpermisoExamenes] = useState(null);
  // Examenes;
  useEffect(() => {
    setpermisoHistorialClinica(tienePermisoTab("HistorialClinica"));
    setpermisoCarnetVacunas(tienePermisoTab("CarnetVacunas"));
    setpermisoRecetas(tienePermisoTab("Recetas"));
    setpermisoHospitalizacion(tienePermisoTab("Hospitalizacion"));
    setpermisoPeluqueria(tienePermisoTab("Peluqueria"));
    setpermisoExamenes(tienePermisoTab("Examenes"));
    // eslint-disable-next-line
  }, []);

  const {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    setopen,
    search,
    input,
    orden,
    setinput,
    setorden,
    cargando,
    setcargando,
    fullBuscador,
    //  STATE
    rows,
    columns,
    // ObjectoActivo,
    pagination,
    // FUNCIONES STATE
    getDataState,
    obtenerState,
    addRowsState,
    remplazarRowsState,
    // agregarState,
    // editarState,
    // eliminarState,
    // eliminarSeleccionState,
    changeObjetoActivoState,
    // rowsImportState,
    seteditar,
    arrayExport,
    setarrayExport,
    puedeExportar,
    desdeOtroLugar,
    changeObjetoActivoStatePropietario,
    setopenPropietarioModal,
    socket,
    eliminadoEstado,
  } = props;

  // eslint-disable-next-line
  const clases = useStyles();
  // eslint-disable-next-line
  const reducer = (previousValue, currentValue) =>
    Number(previousValue) + Number(currentValue);

  const [campoExport] = useState("mascId");
  //clases
  const classes = useStyles();

  const handleChangePage = async (event, newPage) => {
    if (newPage * rowsPerPage + rowsPerPage > rows.length) {
      setcargando(true);
      const res = await getDataState(
        rowsPerPage,
        newPage,
        search,
        input.id,
        orden,
        JSON.stringify(fullBuscador),
        rucempresa
      );

      const data = res.data.data.results;

      setcargando(false);
      const resultado = data.filter((row) => {
        const existe = rows.some((item, index) => {
          return row.mascId === item.mascId;
        });

        return !existe;
      });

      addRowsState(resultado);
    }

    setPage(newPage);
  };

  // eslint-disable-next-line

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    obtenerState(
      event.target.value,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
  };
  const funcionOrdenar = async (column) => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      column.id,
      !orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
    setPage(0);
    setinput(column);
    setorden(!orden);
    setcargando(false);
  };
  const funcionReload = async () => {
    setcargando(true);
    setRowsPerPage(10);
    setPage(0);
    await obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
    setcargando(false);
  };

  useEffect(() => {
    //eslint-disable-next-line

    obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );

    // eslint-disable-next-line
  }, []);

  //si no hay usuarios //rows no cargar el componente
  if (!rows) {
    return <Cargando titulo="Cargando" />;
  }
  if (!pagination) {
    return <Cargando titulo="Cargando" />;
  }
  if (
    !permisoHistorialClinica ||
    !permisoCarnetVacunas ||
    !permisoRecetas ||
    !permisoHospitalizacion ||
    !permisoPeluqueria ||
    !permisoExamenes
  ) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <ToolBarTable
        eliminadoEstado={eliminadoEstado}
        search={search}
        titulo={"Mascotas"}
        arrayExport={arrayExport}
        columns={columns}
        expandible={false}
        campoExport={campoExport}
        tabla="mascota"
        funcionReload={funcionReload}
        pagination={pagination}
        rowsPerPage={rowsPerPage}
        rows={rows}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        fullBuscador={fullBuscador}
        socket={socket}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" id="tabla" size="small">
          {/* <ModalCarnet setopen={setopen} onChangeCarnetActivo={onChangeCarnetActivo}/> */}
          <TableHead>
            <TablaCabecera
              remplazarRowsState={remplazarRowsState}
              search={search}
              input={input}
              setinput={setinput}
              orden={orden}
              setorden={setorden}
              rowsPerPage={rowsPerPage}
              page={page}
              setPage={setPage}
              setcargando={setcargando}
              rows={rows}
              setarrayExport={setarrayExport}
              columns={columns}
              habilitarOrdenar={true}
              funcionOrdenar={funcionOrdenar}
              puedeExportar={puedeExportar}
              desdeOtroLugar={desdeOtroLugar}
            />
          </TableHead>
          <TableBody>
            {cargando ? (
              <TableCell
                size="small"
                align="center"
                colSpan={columns.length + 2}
              >
                <Cargando titulo="Cargando" />
              </TableCell>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <Row
                      eliminadoEstado={eliminadoEstado}
                      campoExport={campoExport}
                      rows={rows}
                      arrayExport={arrayExport}
                      setarrayExport={setarrayExport}
                      row={row}
                      index={index}
                      setopen={setopen}
                      key={row.mascId}
                      changeObjetoActivoState={changeObjetoActivoState}
                      puedeExportar={puedeExportar}
                      desdeOtroLugar={desdeOtroLugar}
                      seteditar={seteditar}
                      changeObjetoActivoStatePropietario={
                        changeObjetoActivoStatePropietario
                      }
                      setopenPropietarioModal={setopenPropietarioModal}
                      socket={socket}
                      tienePermiso={tienePermiso}
                      alertaPermiso={alertaPermiso}
                      permisoHistorialClinica={permisoHistorialClinica}
                      permisoCarnetVacunas={permisoCarnetVacunas}
                      permisoRecetas={permisoRecetas}
                      permisoHospitalizacion={permisoHospitalizacion}
                      permisoPeluqueria={permisoPeluqueria}
                      permisoExamenes={permisoExamenes}
                    />
                  );
                })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default memo(withRouter(Tabla));
